// For slider initialization see: slider.js

// Fix jumping of below content.

import Bus from '../../../shared/js/modules/event-bus';

const navTimelines = document.querySelectorAll('.nav-timeline');
const navTimelineInstances = [];

class NavTimeline {
  constructor(params) {
    this.nav = params.nav;
    this.observer = undefined;
    this.uniqueStr = `${Math.floor(
      Math.random() * Math.floor(Math.random() * Date.now())
    )}`;
    this.currentMinHeight = 0;
  }

  init() {
    this.initObserver();
  }

  initObserver() {
    this.observer = new ResizeObserver(entries => {
      // Avoid error: "ResizeObserver loop completed with undelivered notifications."
      // caused by too many notification in a single animation frame.
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }

        setTimeout(() => {
          this.updateMinHeight();
        }, 0);
      });
    });

    this.observer.observe(this.nav, {
      attributes: false,
      childList: false,
      subtree: false,
    });

    Bus.subscribe(
      'resize',
      `NavTimelineResize-${this.uniqueStr}`,
      this.onResize.bind(this)
    );
  }

  destroyObserver() {
    this.observer?.disconnect();
  }

  resetObserver() {
    this.destroyObserver();
    this.initObserver();
  }

  onResize() {
    this.resetMinHeight();
  }

  updateMinHeight() {
    const targetMinHeight = this.nav.clientHeight;

    if (this.currentMinHeight < targetMinHeight) {
      this.nav.style.minHeight = `${targetMinHeight}px`;
      this.currentMinHeight = targetMinHeight;
    }
  }

  resetMinHeight() {
    this.currentMinHeight = 0;
    this.resetObserver();
  }
}

navTimelines.forEach(nav => {
  const navTimelineInstance = new NavTimeline({
    nav,
  });

  navTimelineInstance.init();
  navTimelineInstances.push(navTimelineInstance);
});
